import React, { useState } from 'react';
import styled from '@emotion/styled';
import { useStaticQuery, graphql } from 'gatsby';
import { motion } from 'framer-motion';
import LazyImage from '../../components/lazy-image';
import Label from '../../components/Label';
import ButtonUnderlined from '../../components/ButtonUnderlined';
import { Link } from 'gatsby';
import StandardPost from '../../components/Insights/standardPost';
import withUrlParams from '../../utils/withUrlParams';
import PropTypes from 'prop-types';
import TitleUnderlined from '../../components/TitleUnderlined';

const BlogOuterPostContainer = styled.div``;

const RelatedContainer = styled.div``;

const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 75px;
  margin-top: 75px;
  @media (max-width: 1000px) {
    margin-bottom: 40px;
    margin-top: 40px;
  }
`;

const RelatedPostContainerOuter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const RelatedPostContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  overflow: hidden;
  width: 100%;
  max-width: 1080px;
`;

const StandardPostContainer = styled.div`
  @media (max-width: 1000px) {
    width: 100%;
    height: 100%;
  }
`;

const BlogItemContainer = styled.div`
  height: 480px;
  width: 420px;
  margin-bottom: 100px;
  @media (max-width: 1000px) {
    width: 90%;
    margin: 0px !important;
    margin-left: 5% !important;
    height: 100%;
    padding-bottom: 50px;
    display: flex;
    flex-wrap: wrap;
  }
  @media (max-width: 600px) {
    display: block;
    width: 90%;
    margin: 0px !important;
    margin-left: 5% !important;
    height: 100%;
    padding-bottom: 50px;
  }
`;

const LabelContainer = styled(motion.div)`
  width: 100%;
  margin-top: 35px;
  margin-bottom: 15px;
`;

const PostTitle = styled(motion.div)`
  font-family: 'DM Serif Text', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 26px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  color: #404040;
  @media (max-width: 600px) {
    font-size: 32px;
    margin-bottom: 10px;
  }
`;

const PostDescription = styled(motion.div)`
  font-family: 'DM Sans', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.01em;
  color: #404040;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ButtonContainer = styled(motion.div)`
  margin-top: 35px;
  @media (max-width: 600px) {
    margin-top: 20px;
  }
`;

const ImageContainer = styled(motion.div)`
  width: 100%;
  height: 245px;
  background-color: #212121;
  @media (max-width: 1000px) {
    width: 100%;
    height: 325px;
  }
  @media (max-width: 550px) {
    height: 225px;
  }
`;

const ImageContainerOuter = styled(motion.div)`
  width: 100%;
  overflow: hidden;
  height: 245px;
  background-color: #212121;
  @media (max-width: 1000px) {
    width: 100%;
    height: 325px;
  }
  @media (max-width: 600px) {
    width: 100%;
  }
  @media (max-width: 550px) {
    height: 225px;
  }
`;

const MetaData = styled.div`
  @media (max-width: 1000px) {
    width: calc(50% - 50px);
    padding-left: 50px;
  }
  @media (max-width: 600px) {
    width: 100%;
    padding: 0px;
  }
`;

const StyledLink = styled(props => <Link {...props} />)`
  width: 100%;
  @media (max-width: 1000px) {
    width: 50%;
  }
  @media (max-width: 600px) {
    width: 100%;
  }
`;

const POST_CATEGORIES = ['Digital', 'Strategy', 'SEO', 'Customer Acquisition'];

const BlogRelated = props => {
  const [count, setCount] = useState(0);
  const data = useStaticQuery(graphql`
    query RelatedBlogQuery {
      allPrismicBlog(sort: { fields: last_publication_date, order: DESC }) {
        nodes {
          id
          tags
          url
          data {
            blog_title {
              text
            }
            seo_description {
              text
            }

            post_category
            featured_image {
              alt
              url
              localFile {
                id
                childImageSharp {
                  fluid(maxWidth: 700) {
                    ...GatsbyImageSharpFluid_withWebp
                    presentationWidth
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  let postCategory = props.category;

  let posts = () => {
    let postCount = 0;
    let maxPosts = 2;
    let elements = [];

    // First, check if there are any posts in the same category as the current post
    let categoryPosts = data.allPrismicBlog.nodes.filter(
      post => post.data.post_category === postCategory && post.url !== props.url
    );

    // If there are no posts in the same category, get all posts from any category
    if (categoryPosts.length === 0) {
      categoryPosts = data.allPrismicBlog.nodes.filter(
        post => post.url !== props.url
      );
    }

    for (var i = 0; i < categoryPosts.length; i++) {
      if (postCount < maxPosts) {
        const post = (
          <StandardPostContainer>
            <BlogOuterPostContainer>
              <BlogItemContainer>
                <StyledLink to={categoryPosts[i].url}>
                  <ImageContainerOuter>
                    <ImageContainer
                      whileHover={{ scale: 1.025, opacity: 0.7 }}
                      transition={{ ease: 'easeOut', duration: 0.3 }}
                    >
                      {categoryPosts[i].data.featured_image && (
                        <LazyImage {...categoryPosts[i].data.featured_image} />
                      )}
                    </ImageContainer>
                  </ImageContainerOuter>
                </StyledLink>

                <MetaData>
                  <LabelContainer>
                    <Label
                      color="#4758eb"
                      text={categoryPosts[i].data.post_category}
                    />
                  </LabelContainer>
                  <Link to={categoryPosts[i].url}>
                    <PostTitle>
                      {categoryPosts[i].data.blog_title.text}
                    </PostTitle>
                  </Link>

                  <PostDescription>
                    {categoryPosts[i].data.seo_description.text}
                  </PostDescription>

                  <ButtonContainer>
                    <ButtonUnderlined
                      color="#4758eb"
                      buttonText={'Read More'}
                      link={categoryPosts[i].url}
                      gatsbyMode={true}
                    />
                  </ButtonContainer>
                </MetaData>
              </BlogItemContainer>
            </BlogOuterPostContainer>
          </StandardPostContainer>
        );
        elements.push(post);
        postCount++;
      }
    }

    if (elements.length === 0) {
      let post = <div>No Related Posts.</div>;
      elements.push(post);
    }

    return elements;
  };

  const handlePostAdd = () => {
    setCount(count + 1);
  };

  return (
    <RelatedContainer>
      <TitleContainer>
        <TitleUnderlined
          underlineColor={props.color}
          textColor={'#ffffff'}
          fontSize={'39px'}
          mobileFontSize={'30px'}
          titleText={'<span>More Insights</span>'}
        />
      </TitleContainer>
      <RelatedPostContainerOuter>
        <RelatedPostContainer>{posts()}</RelatedPostContainer>
      </RelatedPostContainerOuter>
    </RelatedContainer>
  );
};

export default BlogRelated;
